<template>
  <body>
    <Header></Header>
    <div class="center">
      <div class="title_container">
        <img src="mapbox_logo.png" height="50px" width="60px" class="logo" />
        <div class="title_main">Popular List</div>
      </div>
    </div>

    <div class="center">
      <div class="explain">
        <div class="title">Top 5 popular List in main country</div>
        <div class="split"></div>

        <div>Mapbox</div>
        <div>
          This map shows popular movies in the countries where Netflix develops
          best.
        </div>
        <div>
          People can find popular TVS in other country, not only limited in own
          country.
        </div>
      </div>
    </div>

    <div class="center">
      <div class="mapbox_container">
        <div id="map"></div>
      </div>
    </div>
    <div class="center">
      <router-link to="/about" @click.native="scrollToTop">
        <div class="next">
          <img src="next.png" height="50px" width="50px" />
        </div>
      </router-link>
    </div>
  </body>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import Header from "@/components/Header";

export default {
  name: "mapbox",
  components: {
    Header,
  },
  created() {
    this.mapboxglMap = null;
  },
  mounted() {
    mapboxgl.accessToken =
      "pk.eyJ1IjoibHluMTEwMCIsImEiOiJja2drOTR6MGIwM2o5MnV0bjlmdHJ3cHZxIn0.DLJucs6UDOR4_o6wLprjwg";
    var map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/dark-v10",
      center: [-95.7129, 37.0902],
      zoom: 3,
    });

    map.on("load", function () {
      map.loadImage(
        "https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png",
        // Add an image to use as a custom marker
        function (error, image) {
          if (error) throw error;
          map.addImage("custom-marker", image);

          map.addSource("places", {
            type: "geojson",
            data: {
              type: "FeatureCollection",
              features: [
                {
                  type: "Feature",
                  properties: {
                    description:
                      "<strong>Top 5 popular TVS</strong><p>1.Stranger Things</p><p>2.The Umbrella Academy</p><p>3.Unbelievable</p><p>4.100 Metros</p><p>5.Lie to me</p>",
                  },
                  geometry: {
                    type: "Point",
                    coordinates: [-95.7129, 37.0902],
                  },
                },
                {
                  type: "Feature",
                  properties: {
                    description:
                      "<strong>Top 5 popular TVs</strong><p>1.Sex Education</p><p>2.Bodyguard SeasonI</p><p>3.The IT Crowd</p><p>4.Sherlock</p><p>5.The Crown</p>",
                  },
                  geometry: {
                    type: "Point",
                    coordinates: [-3.436, 55.3781],
                  },
                },
                {
                  type: "Feature",
                  properties: {
                    description:
                      "<strong>Top 5 popular TVs</strong><p>1.Kingdom</p><p>2.Grasg Landing on You</p><p>3.Itaewon Class</p><p>4.Hospital PlayList</p><p>5.Signal</p>",
                  },
                  geometry: {
                    type: "Point",
                    coordinates: [127.7669, 35.9078],
                  },
                },
                {
                  type: "Feature",
                  properties: {
                    description:
                      "<strong>Top 5 popular TVs</strong><p>1.El señor de los Cielos</p><p>2.Señora Acero</p><p>3.Rosario Tijeras (Mexico)</p><p>4.Her mothers killer</p><p>5.La Reina del Sur</p>",
                  },
                  geometry: {
                    type: "Point",
                    coordinates: [-102.5528, 23.6345],
                  },
                },
              ],
            },
          });

          // Add a layer showing the places.
          map.addLayer({
            id: "places",
            type: "symbol",
            source: "places",
            layout: {
              "icon-image": "custom-marker",
              "icon-allow-overlap": true,
            },
          });
        }
      );

      // Create a popup, but don't add it to the map yet.
      var popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      });

      map.on("mouseenter", "places", function (e) {
        // Change the cursor style as a UI indicator.
        map.getCanvas().style.cursor = "pointer";

        var coordinates = e.features[0].geometry.coordinates.slice();
        var description = e.features[0].properties.description;

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // Populate the popup and set its coordinates
        // based on the feature found.
        popup.setLngLat(coordinates).setHTML(description).addTo(map);
      });

      map.on("mouseleave", "places", function () {
        map.getCanvas().style.cursor = "";
        popup.remove();
      });
    });

    this.mapboxglMap = map;
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  /* height: 100vh; */
  background-color: #121212;
}
.logo {
  margin-top: 80px;
  /* margin-left: 16%; */
}
.title_container {
  width: 900px;
}
.title_main {
  color: rgba(255, 255, 255, 0.781);
  font-size: 25px;
  margin-top: -40px;
  margin-left: 7.5%;
}
.title {
  font-size: 30px;
  color: burlywood;
  margin-left: 0px;
  margin-top: 0px;
}
.split {
  width: 440px;
  height: 0.1px;
  background: rgb(255, 255, 255, 0.3);
  margin-left: 0px;
  margin-top: 0px;
  margin-bottom: 5px;
}
.explain {
  font-size: 15px;
  color: grey;

  margin-top: 20px;
  background-color: #272727;
  width: 900px;
  border-radius: 13px;
  padding: 10px;
}

.mapboxgl-popup {
  max-width: 400px;
  font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
}

.center {
  display: flex;
  justify-content: center;
}
.mapbox_container {
  /* position: relative; */
  height: 500px;
  width: 900px;
  background: #272727;
  /* display: inline-block; */
  margin-top: 40px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
}

#map {
  /* position: absolute; */
  /* top: 0; */
  /* bottom: 0; */
  width: 860px;
  height: 460px;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
.next {
    margin-top: 50%;
    margin-bottom: 50%;
}
</style>